import { caseApi } from '../services/api';
import { showInAppAlert, showInAppConfirm } from '../services/inAppDialog';

type PromptCaseCloseAfterServiceReportOptions = {
  triggerTaskId?: string | null;
};

export const promptCaseCloseAfterServiceReport = async (
  caseId: string,
  options: PromptCaseCloseAfterServiceReportOptions = {}
) => {
  const normalizedCaseId = String(caseId || '').trim();
  if (!normalizedCaseId) return;

  const shouldClose = await showInAppConfirm('The service report has been sent. Close this case now?', {
    title: 'Close case?',
    confirmLabel: 'Close case',
    cancelLabel: 'Keep case open',
    tone: 'primary'
  });

  if (!shouldClose) return;

  try {
    await caseApi.updateStatus(normalizedCaseId, 'CLOSED', {
      source: 'service-report',
      reason: 'Case closed after service report was sent.',
      triggerTaskId: options.triggerTaskId || null
    });
  } catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
        ? error
        : 'The service report was sent, but the case could not be closed.';
    showInAppAlert(message, {
      title: 'Case close failed',
      tone: 'danger'
    });
  }
};
